import { AiSparkle16 } from 'ui/icons/aurora/16px/AiSparkle16';
import {
  AiSparkleWrapper,
  StyledRadioListTextWrapper,
  StyledCaption,
  StyledBody,
  StyledRecommendedCardContent,
} from 'modules/ai/nba/components/recommendedContents/RecommendedSuggestionCardContent.styles';

interface RecommendedSuggestionCardContentProps {
  suggestionText?: string;
  moodText?: string;
}

export const nbaRecommendationCardIds = {
  card: 'nba-recommended-card',
};

export const RecommendedSuggestionCardContent: React.FC<
  React.PropsWithChildren<RecommendedSuggestionCardContentProps>
> = ({ suggestionText, moodText }: RecommendedSuggestionCardContentProps) => {
  return (
    <StyledRadioListTextWrapper data-test={nbaRecommendationCardIds.card}>
      <AiSparkleWrapper>
        <AiSparkle16 />
      </AiSparkleWrapper>
      <StyledRecommendedCardContent>
        <StyledBody>{suggestionText}</StyledBody>
        <StyledCaption> {moodText}</StyledCaption>
      </StyledRecommendedCardContent>
    </StyledRadioListTextWrapper>
  );
};
